module.exports = __webpack_public_path__ + "Roboto-Regular.94dac78eee406a8c8f04.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Regular.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Regular.woff
// module chunks = styles